import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IbCashAviosInfoComponent } from './ib-cash-avios-info.component';
import { TranslateModule } from '@ngx-translate/core';
import { IbCPipeModule } from 'ib-web-commons/pipes';
import { UpgradeModule } from '@angular/upgrade/static';

const downgradedComponents = [
  IbCashAviosInfoComponent
];

@NgModule({
  declarations: [
    ...downgradedComponents
  ],
  imports: [
    CommonModule,
    TranslateModule,
    IbCPipeModule,
    UpgradeModule
  ]
})
export class IbCashAviosInfoModule {
  static components = [...downgradedComponents];
}
